<template>
  <div class="mini_uploader">
    <div v-if="value" class="uploaded">
      <div @click="preview">查看图片</div>
      <img class="delete_icon" src="//vipcdn.mgtv.com/upload3/201903/0325/delete.png" @click="clear"/>
    </div>
    <div class="to_upload" v-else @click="click_upload">
      <div>点击上传</div>
      <img class="upload_icon" src="//vipcdn.mgtv.com/upload3/201903/0325/upload.png" alt="">
    </div>
    <input type="file" hidden ref="file_input" @change="on_fileinput_change"/>
  </div>
</template>
<script>

  import {upload_file} from '../../../api/myaxios'

  export default {
    name: 'MiniUploader',
    props: ['value'],
    data: function () {
      return {

      }
    },
    methods: {
      click_upload: function () {
        this.$refs.file_input.click();
      },
      clear() {
        this.$emit('input','');
        this.$refs.file_input.value = ''
      },
      on_fileinput_change(e) {
        if (e.target.files.length > 0) {
          const file = e.target.files[0];
          if (file) {
            upload_file(file, (v) => {
              //this.value = v;
              this.$emit('input',v);
            })
          }
        }
        this.$refs.file_input.value = '';
      },
      preview() {
        if (this.value) {
          window.$preview_img_dialog.show({img: this.value})
        }
      }
    },
    mounted() {

    },

    computed: {}
  };
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"
  .mini_uploader
    display block
    height .6rem
    line-height .6rem
    width 3.6rem
    padding 0 .1rem
    font-size .28rem
    color #717171
    .uploaded
      display flex
      align-items center
      div
        color #717171
        font-size .28rem
        text-decoration underline
      .delete_icon
        display block
        width .52rem
        height @width
        margin-left .2rem
        padding .1rem

    .to_upload
      display flex
      align-items center
      div
        color #717171
        font-size .28rem
      .upload_icon
        display block
        width .52rem //.32rem
        padding .1rem
        height @width
        margin-right .1rem


</style>
